<template>
    <div
        :key="item.ColId"
        class="row items-center ma-0 pa-0 mediumdense mr-4"
        style="max-width: 260px;"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
    >
        <q-icon dense class="q-mr-sm" :name="getIcon(item.SourceType, false)" />

        <div class="col ellipsis dense">
            <div :class="getMetricItemClass(item)">{{ item.Title }}</div>
        </div>

        <q-btn
            v-if="item.MetricAggs.Type == 'function' || item.MetricAggs.Type == 'filter' || item.MetricAggs.Type == 'script' || item.MetricAggs.Type == 'filter_script' || item.MetricAggs.Type == 'bucket_script'"
            dense
            round
            flat
            icon="mdi-plus-circle-outline"
            class="ma-0"
            :class="{ 'hidden-element': !hover }"
            @click="metricMenu = []"
        >
            <q-menu>
                <q-list v-if="item.MetricAggs.Type == 'function' || item.MetricAggs.Type == 'filter' || item.MetricAggs.Type == 'script' || item.MetricAggs.Type == 'filter_script'" dense>
                    <q-item
                        v-for="func in item.MetricAggs.FunctionList"
                        :key="func"
                        clickable
                        v-ripple
                        :disable="isDisabledMetric(item, func)"
                        @click="addMetric(item, func)"
                    >
                        <q-item-section avatar>
                            <q-icon :name="metric_types[func].icon" />
                        </q-item-section>
                        <q-item-section>{{ metric_types[func].text }}</q-item-section>
                    </q-item>
                </q-list>
                <q-list v-if="item.MetricAggs.Type == 'bucket_script'" dense>
                    <q-item
                        clickable
                        v-ripple
                        :disable="isDisabledMetric(item, 'bucket')"
                        @click="addMetric(item, 'bucket')"
                    >
                        <q-item-section avatar>
                            <q-icon :name="item.MetricAggs.BucketScript.Icon" />
                        </q-item-section>
                        <q-item-section>{{ item.MetricAggs.BucketScript.Label }}</q-item-section>
                    </q-item>
                </q-list>
            </q-menu>
        </q-btn>

        <q-btn
            dense
            round
            flat
            icon="mdi-help-circle-outline"
            class="ma-0"
            :class="{ 'hidden-element': !hover }"
            style="color: var(--v-checkboxGrey-base);"
            @click="showHelp(item)"
        >
            <q-tooltip anchor="bottom middle" self="top middle" :delay="350">
                <span>{{ getMetricHelp(item) }}</span>
            </q-tooltip>
        </q-btn>
    </div>
</template>

<script>
    import { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QTooltip } from 'quasar';

    export default {
        components: { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QTooltip },
        data: function () {
            return {
                metricMenu: [],
                hover: false,
            }
        },
        props: {
            item: Object,
            showHelp: null,
            isDisabledMetric: null,
            addMetric: null,
            getMetricHelp: null,
            getMetricItemClass: null,
            getIcon: null,
            metric_types: null,
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style scoped>
    .hidden-element {
        visibility: hidden;
    }

    .columns-two {
        column-count: 2;
    }

    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .metric_normal {
    }

    .metric_inuse {
        color: cornflowerblue;
    }

    .metric_usedup {
        color: silver;
    }
</style>
